import { Routes } from 'constants/index'
import { Button } from 'eezy-components'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { AuthStore } from 'stores'
import { useInstance } from 'util/di'

import AstronautAnimation from '../../components/Astronaut'

import * as S from './styled'

const NotFound = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { session } = useInstance<AuthStore>('AuthStore')

  const needsOnboarding = useMemo(
    () => Boolean(!session?.isAdmin && session?.needsOnboarding),
    [session?.isAdmin, session?.needsOnboarding]
  )

  const handleNavigation = () => {
    if (needsOnboarding) {
      navigate(Routes.PortfolioUpload)
    } else {
      navigate('/')
    }
  }

  return (
    <>
      <S.Container>
        <AstronautAnimation />
        <S.Title variant="h5">{t('page_not_found.title')}</S.Title>
        <Button color="primary" onClick={handleNavigation}>
          {t('page_not_found.go_back_home')}
        </Button>
      </S.Container>
    </>
  )
}

export default NotFound
